import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildYourCommunityPartOneOverlayComponent } from './build-your-community-part-one-overlay.component';
import { CommunityListComponentModule } from '@lists/_index';

@NgModule({
  imports: [CommonModule, CommunityListComponentModule, BuildYourCommunityPartOneOverlayComponent],
  exports: [BuildYourCommunityPartOneOverlayComponent],
})
export class BuildYourCommunityPartOneOverlayModule {}
